
<div class="flex flex-row gap-2">
  <span [ngStyle]="{'color': colorClass}" class="text-m material-symbols-rounded" id="srs-vote-selection-icon" >{{ iconName }}</span>
  <button *ngIf="hasComment" (click)="openPopover(commentPopover)">
    <app-view-votes-popover
      #commentPopover
      id="cib-vote-comment-popover"
      popoverTitle="Ballot Comment"
      [votePopoverItems]="voteCommentPopoverItems"
    ></app-view-votes-popover>

    <span
      [class]="ViewVoteIconsConstants.chatBubble.colorClass"
      class="text-m material-symbols-rounded text-darkBlue-600"
      id="cib-vote-comment-icon"
    >
      {{ ViewVoteIconsConstants.chatBubble.iconName }}
    </span>
  </button>

  <button *ngIf="showingDocumentIcon" (click)="openVoteDocumentsPopover(voteDocumentsPopover)">
    <app-votes-documents-popover
      #voteDocumentsPopover
      id="cib-vote-documents-popover"
      popoverTitle="Authorisation Documents"
      ballotType="{{BallotType}}"
      ballotId="{{vote?.ballotId}}"
      voteId="{{voteId}}"
    ></app-votes-documents-popover>
    <span
      [class]="ViewVoteIconsConstants.draft.colorClass"
      class="text-blue-500 text-m material-symbols-rounded"
      id="cib-vote-document-icon">
      {{ ViewVoteIconsConstants.draft.iconName }}
    </span>
  </button>

  <span
    *ngIf="hasDocument"
    [class]="ViewVoteIconsConstants.howToVote.colorClass"
    class="text-m material-symbols-rounded text-grey-800"
    id="cib-vote-proxy-vote-icon"
  >
    {{ ViewVoteIconsConstants.howToVote.iconName }}
  </span>

  <button *ngIf="hasHistories" (click)="openPopover(historyPopover)">
    <app-view-votes-popover
      #historyPopover
      id="cib-vote-history-popover"
      popoverTitle="Vote History"
      [votePopoverItems]="voteHistoryPopoverItems"
    ></app-view-votes-popover>
    <span
      [class]="ViewVoteIconsConstants.history.colorClass"
      class="text-m material-symbols-rounded text-grey-800"
      id="cib-vote-history-icon"
    >
      {{ ViewVoteIconsConstants.history.iconName }}
    </span>
  </button>
</div>
